"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/checkmark/24.js"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _getColor = require("../../../common/getColor");
var _removeTags = require("../../../common/removeTags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.page-accordion-container .bx--accordion__heading:focus::before {\n  border-width: 0px; }\n\n.page-accordion-container .bx--accordion__heading:hover::before {\n  opacity: 0.3; }\n\n.page-accordion-container .bx--accordion__title {\n  color: #e41b13;\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 16px;\n  margin: 0px; }\n\n.page-accordion-container .bx--accordion__content {\n  padding-top: 16px;\n  padding-left: 0px; }\n\n.page-accordion-container .accordion-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px; }\n  .page-accordion-container .accordion-content .item {\n    display: flex;\n    gap: 16px; }\n    .page-accordion-container .accordion-content .item .icon-container > svg {\n      color: #e41b13;\n      margin-top: -4px; }\n    .page-accordion-container .accordion-content .item .text-container {\n      display: flex;\n      flex-direction: column; }\n      .page-accordion-container .accordion-content .item .text-container .downloadlinkbox-container {\n        padding-left: 0px; }\n      .page-accordion-container .accordion-content .item .text-container .downloadlink-container {\n        padding-bottom: 0px; }\n";
  const fileName = "PageAccordion_PageAccordion";
  const element = document.querySelector("style[data-sass-component='PageAccordion_PageAccordion']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AccordionContent = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, content.map(el => {
    const price = el.productprice?.length > 0 && el.productprice[0]?.price;
    const priceColor = el.productprice?.length > 0 && el.productprice[0]?.title_color?.name;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "item",
      key: el.id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-container"
    }, /*#__PURE__*/_react.default.createElement(_.default, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-08"
    }, Array.isArray(el.description[0]) ? el.description[0] : el.description, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: (0, _getColor.getColor)(priceColor)
      }
    }, price ? Array.isArray(price) ? ` ${price[0]}` : ` ${price}` : '')), el.link && /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      items: [{
        link: el.link
      }]
    })));
  }));
};
const PageAccordion = _ref2 => {
  let {
    item
  } = _ref2;
  const elements = item.accordion_element;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-accordion-container sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Accordion, null, elements.map(el => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.AccordionItem, {
      key: el.id,
      title: (0, _removeTags.removeTags)(el.title),
      open: true
    }, /*#__PURE__*/_react.default.createElement(AccordionContent, {
      content: el.product_description
    }));
  })));
};
PageAccordion.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = PageAccordion;